import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivationStart, NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BreadcrumbService } from '../../../core';
import { MatDialog } from '@angular/material/dialog';
import { UnsavedChangesDialog } from '../../dialogs/unsaved-change-dialog/unsaved-changes-dialog.component';
import { AuthService } from 'src/app/modules/core/auth/services/auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
    selector: 'app-simulation-admin-layout',
    templateUrl: './simulation-admin-layout.component.html',
    styleUrls: ['./simulation-admin-layout.component.scss'],
})
export class SimulationAdminLayoutComponent implements OnInit {
    @ViewChild('snav')
    snav: MatSidenav;

    currentYear = new Date().getFullYear();
    mobileQuery: MediaQueryList;
    role$: Observable<string>;
    breadcrumb = '';
    dynamicBreadcrumb = false;

    role: string;

    activeMenu = false;

    panelOpenState = false;

    private mobileQueryListener: () => void;

    breadcrumbItems$ = this.breadcrumbService.breadcrumbItems$;
    isStandalonePage = false;

    fullname$: Observable<string>;

    childComponent: any

    constructor(
        private authService: AuthService,
        public cdr: ChangeDetectorRef,
        media: MediaMatcher,
        private router: Router,
        private breadcrumbService: BreadcrumbService,
        private dialog: MatDialog,
        private ngxService: NgxUiLoaderService,
    ) {
        this.mobileQuery = media.matchMedia('(max-width: 1100px)');
        this.mobileQueryListener = () => cdr.detectChanges();
        this.mobileQuery.addEventListener('change', this.mobileQueryListener);
    }

    public onRouterOutletActivate(event : any) {
        this.childComponent = event
    }

    changeActive() {
        this.panelOpenState = false;
        this.activeMenu = false;
    }

    ngOnInit() {
        this.ngxService.start();
        // this.authService.fetchUserAttrs();
        this.authService.tryReLogin();
        this.router.events
            .pipe(filter(e => e instanceof NavigationEnd || e instanceof ActivationStart))
            .subscribe(async e => {
                if (e instanceof ActivationStart) {
                    const e1 = e as ActivationStart;
                    this.breadcrumb = (e1 && e1.snapshot && e1.snapshot.data && e1.snapshot.data.breadcrumb) || '';
                    this.dynamicBreadcrumb = !!(
                        e1 &&
                        e1.snapshot &&
                        e1.snapshot.data &&
                        e1.snapshot.data.dynamicBreadcrumb
                    );
                }

                if (e instanceof NavigationEnd) {
                    if (!this.breadcrumb && !this.dynamicBreadcrumb) {
                        this.breadcrumbService.updateBreadCrumbItems([]);
                        this.breadcrumbService.clearActions();
                    }
                    this.isStandalonePage = e.url.indexOf('static-pages') >= 0 ? true : false;
                }
            });
        this.ngxService.stop();
    }

    ngOnDestroy(): void {
        this.mobileQuery.removeEventListener('change', this.mobileQueryListener);
    }


    logout() {
        if (this.childComponent.childComponent.isDirty) {
            this.dialog.open(UnsavedChangesDialog).afterClosed().subscribe(result => {
                if (result) {
                    this.authService.logout();
                }
            })
        } else {
            this.authService.logout();
        }
    }
}
